import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { CdnUtils } from 'utils';

interface Props {
    uploadedImageUrl?: string;
    getUploadAction: (action?: () => Promise<string | undefined>) => void;
}

export const ImageUpload: React.FC<Props> = ({uploadedImageUrl, getUploadAction}) => {
    const [selectedFile, setSelectedFile] = useState<File>();
    const [preview, setPreview] = useState<string>();

    // create a preview as a side effect, whenever selected file is changed
    useEffect(() => {
        if (!selectedFile) {
            setPreview(undefined);
            return;
        }

        const objectUrl = URL.createObjectURL(selectedFile);
        setPreview(objectUrl);

        // free memory when ever this component is unmounted
        return () => URL.revokeObjectURL(objectUrl);
    }, [selectedFile]);
    
    useEffect(() => {
        const uploadImage = async (): Promise<string | undefined> => {
            if (!selectedFile) {
                return undefined;
            }

            const cdn = new CdnUtils();
            const fileUrl = await cdn.uploadFile(selectedFile);
            return fileUrl;
        };

        if (getUploadAction) {
            return getUploadAction(selectedFile ? uploadImage : undefined);
        }

    }, [selectedFile, getUploadAction]);

    const onSelectFile: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        if (!e.target.files || e.target.files.length === 0) {
            setSelectedFile(undefined);
            return;
        }

        // We're uploading only 1 image, never multiple
        setSelectedFile(e.target.files[0]);
    };

    return (
        <Stack direction="row" spacing={2} sx={{ alignItems: 'center', display: 'flex' }}>
            <input type="file" onChange={onSelectFile} />
            {(selectedFile || !!uploadedImageUrl) && (
                <img src={preview || uploadedImageUrl} width="300" style={{ margin: '2px' }} />
            )}
        </Stack>
    );
};
